import { Popover, Typography } from '@cobliteam/ui/components';
import { PopoverContent, PopoverTrigger } from '@cobliteam/ui/components/Popover';
import { FormControl, FormField, FormItem, FormLabel, FormMessage, Input } from '@cobliteam/ui/form';
import Icon from '@cobliteam/ui/icons';

const InfoPopover = () => (
  <Popover>
    <PopoverTrigger>
      <Icon name='circle-help' />
    </PopoverTrigger>
    <PopoverContent align='start' side='bottom' portal={false}>
      <Typography className='mb-2' variant='description-title'>
        O que é um nº de matrícula?
      </Typography>
      <Typography variant='body' className='w-60'>
        É um identificador único atribuído a um condutor para fins de registro e identificação.
      </Typography>
    </PopoverContent>
  </Popover>
);

const DriverRegistryInput = () => {
  return (
    <FormField name='registryId'>
      {({ field }) => (
        <FormItem className='w-full space-y-1 pt-[2px]'>
          <FormLabel className='flex items-center gap-2'>
            Matrícula <InfoPopover />
          </FormLabel>
          <FormControl>
            <Input type='text' {...field} value={field.value || ''} placeholder='Nº da matrícula' />
          </FormControl>
          <FormMessage />
        </FormItem>
      )}
    </FormField>
  );
};

export default DriverRegistryInput;
